export default __webpack_public_path__ + "static/media/down-arrow.7258ecd3.svg";